import styled from "styled-components";
import { Button } from "../../../components/common/Button";
import type { SubscriptionMode } from "../hooks/useSubscriptionMode";

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 32px;
`;

type Props = {
  mode: SubscriptionMode;
  canCreate: boolean;
  isSubmitting: boolean;
  onCancel: () => void;
  onDelete?: () => void;
};

export const SubscriptionFormActions = ({
  mode,
  canCreate,
  isSubmitting,
  onCancel,
  onDelete,
}: Props) => {
  return (
    <ButtonGroup>
      {mode === "create-new" && canCreate && (
        <Button
          type="submit"
          variant="primary"
          fullWidth
          loading={isSubmitting}
          loadingText="Salvataggio..."
          disabled={isSubmitting}
        >
          SALVA ISCRIZIONE
        </Button>
      )}

      {mode === "edit-temporary" && onDelete && (
        <Button
          type="button"
          variant="danger"
          fullWidth
          onClick={onDelete}
          disabled={isSubmitting}
        >
          ELIMINA ISCRIZIONE
        </Button>
      )}

      <Button
        type="button"
        variant="outline"
        fullWidth
        onClick={onCancel}
        disabled={isSubmitting}
      >
        INDIETRO
      </Button>
    </ButtonGroup>
  );
};
